var modal;

(function () {
    modal = {
        fromURL: openModalFromURL,
        createModalLoader: createModalLoader
    };
    
    function createModalLoader() {
        var $modal = $('<div/>', {
            "class": "modal fade",
            "tabindex": -"1",
            "role": "dialog",
            "aria-hidden": "true"
        });

        var $modalDialog = $('<div/>', {
            "class": "modal-dialog",
            "role": "document"
        });

        var $modalContent = $('<div/>', {
            "class": "modal-content loading"
        });

        $modal.append($modalDialog);
        $modalDialog.append($modalContent);
        
        $modal.$modalDialog  = $modalDialog;
        $modal.$modalContent = $modalContent;

        return $modal;
    }

    /**
     * @typedef OpenModalFromURLOptions
     * @prop {string} url The URL to load
     * @prop {string|JQuery.PlainObject} [data] Data to send to the server
     * @prop {string} [type="GET"] The type of request to make
     * @prop {(this: TElement, responseText: string, textStatus: JQuery.Ajax.TextStatus, jqXHR: JQuery.jqXHR) => void} [callback]
     */

    /**
     * @param {OpenModalFromURLOptions|string} optionsOrURL
     */
    function openModalFromURL(optionsOrURL) {
        /** @type {OpenModalFromURLOptions} */
        var options;

        if (typeof optionsOrURL === 'string') options = {url: optionsOrURL};
        else options = optionsOrURL;

        var $modal = createModalLoader();

        /** @type {JQuery} */
        var $modalContent = $modal.$modalContent;

        /** @type {JQuery} */
        var $target = $modalContent;


        $modal.appendTo(document.body).modal();

        /**
         * @param {JQuery} $a 
         * @param {JQuery} $b 
         */
        function areSameModalElements($a, $b) {
            var modalClasses = ['modal', 'modal-dialog', 'modal-content'];

            for (var i = 0; i < modalClasses.length; i++) {
                var modalClass = modalClasses[i];
                var aHasModalClass = $a.hasClass(modalClass);
                var bHasModalClass = $b.hasClass(modalClass);

                if (aHasModalClass && bHasModalClass) return true;
            }

            return false;
        }

        /**
         * @param {JQuery} $from 
         * @param {JQuery} $to 
         */
        function replaceModalElements($from, $to) {
            var oldClassName = $to.attr('class');
            
            var attributes = $from.get(0).attributes;

            for (var i = 0; i < attributes.length; i++) {
                $to.attr(attributes[i].name, attributes[i].value);
            }

            $to.addClass(oldClassName);

            var $fromChildren = $from.children();
            var $toChildren   = $to.children();
            
            if ($fromChildren.length === 1 && areSameModalElements($fromChildren, $toChildren)) {
                replaceModalElements($fromChildren, $toChildren);
            } else {
                $to.children().remove();
                $to.append($from.children());
            }

            return $to;
        }

        $.ajax({
            url: options.url,
            type: options.type || "GET",
            dataType: "html",
            data: options.data
        })
            .done(function (responseText) {
                var $responseElements = $($.parseHTML(responseText, document, true));
                var $scripts = $responseElements.filter('script');
                var $loadedChild = $responseElements.not($scripts);

                if ($loadedChild.hasClass('modal')) replaceModalElements($loadedChild.filter('.modal'), $modal).modal('show');
                else if ($loadedChild.hasClass('modal-dialog')) replaceModalElements($loadedChild.filter('.modal-dialog'), $modal.$modalDialog);
                else if ($loadedChild.hasClass('modal-content')) replaceModalElements($loadedChild.filter('.modal-content'), $modal.$modalContent);
                else $loadedChild.appendTo($target);

                $scripts.each(function () {
                    $.globalEval(this.innerText);
                });
                
                $modal.modal('handleUpdate');
                $modalContent.removeClass('loading');

                if (jQuery.isFunction(options.callback)) { 
                    options.callback.apply(this, arguments);
                }
            });

        $modal.on('hidden.bs.modal', function (e) {
            $modal.modal('dispose').remove();
        });

        return $modal;
    }
})();